module.exports = "<span ng-if=\"!$ctrl.canShow\" class=\"spinner-container\"><i class=\"icon-loading animate-spin\"></i></span><sc-query-builder ng-if=\"$ctrl.canShow\" group=\"$ctrl.group\"></sc-query-builder>"


//////////////////
// WEBPACK FOOTER
// ./src/filter/query-builder/query-builder-container.component.html
// module id = 283
// module chunks = 0